import { Card, CardBody, Col, Row } from 'reactstrap';
import { useKnowledgeTestDispatch, useKnowledgeTestState } from '../../../contexts/KnowledgeTestContext';
import { useDict } from '../../../contexts/LanguageContext';
import { dateFormatter } from '../../../utils/dateHelper';
import { appendLocale } from '../../../utils/helper';

const MyProfile = (props) => {
    const { profileData } = props;

    const knowledgeTestDispatch = useKnowledgeTestDispatch();
    const knowledgeTestState = useKnowledgeTestState();

    const dict = useDict();

    return (
        <>
            <Card className="card_profile">
                <CardBody className="myDetails__cardBody">
                    <Row>
                        <Col xs={12} sm={4}>
                            <p className="bold-text">{dict.nameCompanyName}:</p>
                        </Col>
                        <Col xs={12} sm={8}>
                            <Row className="align-items-center p-0 g-0">
                                <p className="myDetails__name">
                                    {profileData?.last_name +
                                        ' ' +
                                        profileData?.first_name || 'N/A'}
                                </p>
                                <div
                                    className={
                                        profileData?.is_verified
                                            ? 'myDetails__badge myDetails__badge-verified'
                                            : 'myDetails__badge myDetails__badge-unverified'
                                    }
                                >
                                    {profileData?.is_verified
                                        ? dict.verified
                                        : dict.unverified}
                                </div>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={4}>
                            <p className="bold-text">{dict.email}:</p>
                        </Col>
                        <Col xs={12} sm={8}>
                            <p>{profileData?.email || 'N/A'}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={4}>
                            <p className="bold-text">{dict.phoneNo}:</p>
                        </Col>
                        <Col xs={12} sm={8}>
                            <p>
                                {profileData?.phone_no
                                    ? `(+${profileData.country_code}) ${profileData.phone_no}`
                                    : 'N/A'}
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={4}>
                            <p className="bold-text">
                                {dict.dobIncorporated}:
                            </p>
                        </Col>
                        <Col xs={12} sm={8}>
                            <p>{dateFormatter(profileData?.user_detail?.dob) || 'N/A'}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={4}>
                            <p className="bold-text">{dict.gender}:</p>
                        </Col>
                        <Col xs={12} sm={8}>
                            <p>{profileData?.user_detail?.gender[appendLocale('name')] || 'N/A'}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={4} className="d-flex">
                            <p className="bold-text">
                                {dict.idTypeROC}:{' '}
                            </p>
                        </Col>
                        <Col xs={12} sm={8}>
                            <p>
                                {profileData?.user_detail
                                    ?.identification_type[appendLocale('name')] || 'N/A'}
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={4}>
                            <p className="bold-text">
                                {dict.idNoROCNo}:
                            </p>
                        </Col>
                        <Col xs={12} sm={8}>
                            <p>
                                {profileData?.user_detail?.identification_no ||
                                    'N/A'}
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={4}>
                            <p className="bold-text">
                                {dict.investorCategory}:
                            </p>
                        </Col>
                        <Col xs={12} sm={8}>
                            <p>
                                {profileData?.wallets?.[0].investor_category[appendLocale('name')] ||
                                    'N/A'}
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={4}>
                            <p className="bold-text">
                                {dict.knowledgeTest}:
                            </p>
                        </Col>
                        <Col xs={12} sm={8}>
                            <p>
                                {!knowledgeTestState.isPassedKnowledgeTest ?
                                    (
                                        <div className="d-flex">
                                            {dict.notPassed} -

                                            <div
                                                className="myProfile__knowledge-test-link ml-1"
                                                onClick={() => { knowledgeTestDispatch({ type: 'viewKnowledgeTestModal' }) }}
                                            >
                                                {dict.completeKnowledgeTestNow}
                                            </div>
                                        </div>
                                    )
                                    :
                                    (
                                        <div>{dict.passed}</div>
                                    )
                                }
                            </p>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            <div style={{ padding: '1%', marginTop: '1%' }}>
                <div>
                    {dict.contactUs1}{' '}
                    <a href="mailto:thaisupport@capbay.com">thaisupport@capbay.com</a>{' '}
                    {dict.contactUs2}
                </div>
                <br />
            </div>
        </>
    );
};

export default MyProfile;
